import React, { useState, useEffect } from 'react';

export default function Description({ data, onReadMoreClick, click, id = '' }) {
  const [currentCount, setCurrentCount] = useState(50);
  const [tempDescription, setTempDescription] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (data && data.length > 0) {
      console.log('data', data);
      setDescription(data);
      setTempDescription(data.substring(0, currentCount));
    }
  }, [data]); 

  let readMoreClick = () => {
    let coun = description.length; //parseInt(currentCount) + 10
    setCurrentCount(coun);
    setTempDescription(description);
    onReadMoreClick();
  };

  return (
    <>
      <span className="cursorPointer" onClick={click}>
        {tempDescription}
      </span>
      {currentCount >= description.length ? null : (
        <span
          className="cursorPointer text-primary readMore"
          // id={`${id}_connect_speaker_read_more`}
          onClick={() => {
            readMoreClick();
          }}
        >
          ...Read More
        </span>
      )}
    </>
  );
}
